import { useBalance } from '../model'
import { useCurrentOrg } from '@/app/entities/org/model'
import { Button } from '@/common/ui/Form/Button'
import { TokenAmount } from '@/common/ui/TokenAmount'
import { openInsufficientBalanceModal } from '@/app/entities/insufficientBalance/model'
import { InsufficientBalanceModal } from '@/app/entities/insufficientBalance/ui/InsufficientBalanceModal'

export const BalanceButton = () => {
    const { data: currentOrg, isLoading: isCurrentOrgLoading } = useCurrentOrg()
    const { data: balance, isPending: isBalancePending } = useBalance(currentOrg?.id)
    const isBalanceLoading = isCurrentOrgLoading || !currentOrg?.id || isBalancePending || balance === undefined
    const handleOpenAddTokens = () => {
        openInsufficientBalanceModal({ step: 2 })
    }

    if (isBalanceLoading) {
        return (
            <Button variant='filled' emphasis='accent' className='gap-2 rounded-full mr-4 mt-[-3px]'>
                <span className='loading loading-spinner loading-sm'></span>
            </Button>
        )
    }
    return (
        <>
            <InsufficientBalanceModal />
            <TokenAmount
                as={Button}
                variant='filled'
                emphasis='accent'
                className='rounded-full'
                value={balance.available_now}
                total={balance.total}
                trial={balance.trial}
                onLowBalancePopupAction={handleOpenAddTokens}
                onClick={handleOpenAddTokens}
                title='Ваш текущий баланс'
                aria-label='Ваш текущий баланс'
            />
        </>
    )
}
